import type { ReactNode } from 'react';

interface Props {
    children: ReactNode;
    onClick: () => void;
}

export default function SearchResult({ children, onClick }: Props) {
    return (
        <li>
            <button
                type='button'
                className='w-full px-4 py-1 text-left hover:bg-theme-600 round:rounded-lg transition-colors cursor-pointer'
                onClick={onClick}
            >
                {children}
            </button>
        </li>
    );
}
